import { Box, Divider, Grid2 as Grid, Tooltip, Typography } from '@mui/material';
import { formatDateAsDayMonthYear } from '@/utils/dateFormatter';
import type { SectionMetadata } from '../utils/getSectionMetadata';

export type FormSectionProps = {
  title: string;
  children: React.ReactNode;
  metadata?: SectionMetadata;
};

export const FormSection = ({ title, children, metadata }: FormSectionProps) => (
  <Grid container spacing={4} alignItems='flex-start' sx={{ mb: 4 }}>
    {/* Section Title */}
    <Grid
      size={{ xs: 12, md: 2 }}
      display='flex'
      flexDirection='column'
      alignItems={{ xs: 'flex-start', md: 'flex-end' }}
      justifyContent='flex-start'
      textAlign={{ xs: 'left', md: 'right' }}
    >
      <Typography variant='h6'>{title}</Typography>
      {metadata?.lastChangedAt && metadata?.lastChangedBy && (
        <Box sx={{ mt: 1 }}>
          <Tooltip title='Last Changed On' arrow placement='left' enterDelay={300}>
            <Typography
              variant='caption'
              color='text.secondary'
              display='block'
              sx={{ cursor: 'default' }}
            >
              {formatDateAsDayMonthYear(metadata.lastChangedAt)}
            </Typography>
          </Tooltip>
          <Tooltip title='Last Changed By' arrow placement='left' enterDelay={300}>
            <Typography
              variant='caption'
              color='text.secondary'
              display='block'
              sx={{ cursor: 'default' }}
            >
              {metadata.lastChangedBy}
            </Typography>
          </Tooltip>
        </Box>
      )}
    </Grid>
    {/* Divider: hide on xs */}
    <Divider
      orientation='vertical'
      flexItem
      sx={{
        mx: 2,
        display: { xs: 'none', md: 'block' },
      }}
    />
    <Grid size={{ xs: 12, md: 8 }}>{children}</Grid>
  </Grid>
);
